import { render, staticRenderFns } from "./versionInfo.vue?vue&type=template&id=21f90cc6&"
import script from "./versionInfo.vue?vue&type=script&lang=ts&"
export * from "./versionInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f90cc6')) {
      api.createRecord('21f90cc6', component.options)
    } else {
      api.reload('21f90cc6', component.options)
    }
    module.hot.accept("./versionInfo.vue?vue&type=template&id=21f90cc6&", function () {
      api.rerender('21f90cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/versionInfo.vue"
export default component.exports